import { useMutation } from "react-query"
import { createJob } from "./newJobApi"
import { NewJobResponse } from "./newJobModel"
import { notification } from "antd"

export const useCreateNewJobMutation = (onSuccess?: (response: NewJobResponse) => void) => {
  return useMutation({
    mutationFn: createJob,
    onSuccess: (response) => onSuccess?.(response),
    onError: () => {
      notification.error({message: 'There was a problem creating the job.'})
    }
  })
}
